// extracted by mini-css-extract-plugin
module.exports = {"bottom_menu":"BottomMenu_bottom_menu__37FwC","menu_item":"BottomMenu_menu_item__y0fyw","menu_item_selected":"BottomMenu_menu_item_selected__2Kmaw"};